import { isToday } from '@/locales/dates';

const BillboardsWithAllEvents = [3510, 3512];
const BillboardsEventsMobileBackgroundPositionToLeft = [2409, 2411];
const BillboardsEventsMobileBackgroundPositionToRight = [2556, 1478];
const billboardsWithShortenTemplates = [
  3167, 1626, 3147, 1896, 3244, 3242, 3241, 3240, 3239, 3250, 3249, 3248, 3252,
  3312, 3212, 3323, 3324, 3322, 3319, 3320, 3321, 3436, 3445, 3461, 3477, 3529,
  3504, 3557, 3560, 3574, 3579, 3587, 3590, 3615, 3622, 3623, 3632, 1638,
];
const EventsWithNewCommissions = [
  226166, 226167, 213545, 213570, 213571, 213572,
];

const eventsWithSaleLabel = [258897, 258899, 266469];

const eventsTemplateHybrid = [241138];
const usersTemplateHybrid = [];

const eventsTemplateHiddenMap = [228539];
const usersTemplateHiddenMap = [];

const userToViewAvailability = [];
const eventToViewAvailability = [];

const eventsWithDarkMode = [213835];
const eventsRemoveNoCustomTicketButton = [213835];
const eventsRemoveApplyAllCustomTicketButton = [213835];

const BillboardDisabledHighlightedEvents = [
  2751, 2771, 2818, 2852, 3012, 3166, 3196, 3202, 3203, 3232, 3294, 3299, 3355,
  3364, 3434, 3474, 3482, 3495, 3503, 3510, 3512, 3534, 3537, 3538, 3559, 1423,
  3566, 3575, 3470, 3591, 3308, 3589, 3604, 3610
];
const BillboardRemoveEventsBanner = [3012];
const BillboardsEventsWithMXN = [238298, 238296, 238297];
const BillboardsCardDefaultAction = [2818, 3550, 3566];
const BillboardsRemoveTags = [1574, 2916];
const BillboardsRemoveOpenCard = [3203, 1638];

const BillboardOdysseySoldOut = [2751];
// const BillboardOdysseySoldOut = [2751];
const eventsSoldOut = [238296, 238297];
// const eventsSoldOut = [238296, 238297, 238298];

const fanPassword = {
  268333: [
    {
      start_date: '2026-06-23T14:00:00Z',
      end_date: '2026-06-26T04:00:00Z',
      pass: 'DRAGME',
    },
    {
      start_date: '2026-06-25T14:00:00Z',
      end_date: '2026-06-26T04:00:00Z',
      pass: 'UNDRASHES',
    },
  ],
  226813: [
    {
      start_date: '2026-06-15T00:00:00Z',
      end_date: '2026-06-30T23:59:00Z',
      pass: 'ALPHA',
    },
    {
      start_date: '2026-06-15T00:00:00Z',
      end_date: '2026-06-30T23:59:00Z',
      pass: 'BETA',
    },
  ],
};

const promotionPreLoaded = {
  242478: 'NCMX15NAVIDAD',
  247186: 'GENERAL2X1',
  249585: 'ALEMAN2X1',
  249588: 'AMALIA2X1',
  249632: 'ALEMAN2X1',
  249633: 'ALEMAN2X1',
  249736: 'NTCBBVA25',
  252909: 'BBVA30',
  252905: '2X1',
  249323: '3X2POPTOUR',
  254313: 'MAYOO2X1',
  249323: '2X1POPTOUR',
  252595: 'TOLUCA11',
  251462: 'TWY2X1',
  258936: 'REGULAR2X1',
  252982: 'MUSICAMEXA',
  252980: 'MUSICAMEXA',
  252976: 'MUSICAMEXA',
  260200: '2X1',
  260204: '2X1',
  260205: '2X1',
  261186: 'BBVA',
  261425: 'FAMILIALDCR',
  261434: 'FAMILIALDCR',
  261124: 'TEST',
  258725: 'COMISARIO',
  260551: 'BBVA20',
  262287: 'FAMILIALDCR',
  262285: 'FAMILIALDCR',
  258792: 'HEROES',
  250028: 'MISSALEXA',
  262601: 'LDCR',
  254206: 'VICTORIA',
  262914: 'PRE31MIN',
  261884: 'FOREVER',
  259782: 'FLASHSALE',
  260466: 'LAHOLANDESA2X1',
  260579: '2X1',
  260661: 'GA2X1',
  264072: 'BANORTE10',
  258721: 'ARDEENMI',
  261677: '2X1TOL',
  263844: 'TEST2X1',
  261062: 'PROMO2X1',
  261680: '2X1PUE',
  264409: '2X1SHOW',
  262923: 'PROMO3X2',
  261681: 'VER2X1',
  261719: '3X2LM',
  261504: 'GOLDMAN',
  264689: 'RZ4X3',
  261758: '2X1',
  265439: 'BBVA',
  259733: 'SA3X2',
  265340: '30DESC',
  264001: 'FM2025',
  264565: 'PREFERENTE',
  266189: 'FIN2X1',
  266190: 'FIN2X1',
  266202: 'FIN2X1',
  266191: 'FIN2X1',
  266203: 'FIN2X1',
  266176: 'FIN4X3',
  266184: 'FIN4X3',
  265933: 'FAMILIA',
  265932: 'FAMILIA',
  266469: '40AMEX',
  261111: '2X1',
  263766: 'AMIGOSSAMMY',
  266181: '4X3',
  266182: '4X3',
  266183: '4X3',
  266186: '4X3',
  266187: '4X3',
  266192: '2X1',
  266193: '2X1',
  266194: '2X1',
  266195: '2X1',
  266196: '2X1',
  266197: '2X1',
  266198: '2X1',
  266199: '2X1',
  266200: '2X1',
  266204: '2X1',
  266205: '2X1',
  266206: '2X1',
  266207: '2X1',
  266208: '2X1',
  266209: '2X1',
  254672: 'MARTIN60',
  259301: 'MARTIN',
  254459: 'BLACKFRIDAY',
  254671: 'MARTIN50',
  258907: '2X1',
  258908: '30OFF',
  258905: '30OFF',
  258909: '30OFF',
  263820: 'ZV2X1',
  263159: 'BABAS2X1',
  261024: '30OFF',
  266636: 'PREVENTA20',
  265000: 'PREVENTA20',
  261525: 'BOLETIA2X1',
  265458: 'PAREJA',
  261462: 'BUENFIN',
  265050: 'BUENFIN15',
  266528: 'BUENFIN15',
  262462: '3X2TRONO',
  264763: 'DESP1',
  264761: 'DESP1',
  267150: 'PREVENTA',
  267170: 'PREVENTA',
  266043: 'BUENFIN',
  260166: 'BODA',
  266397: 'LOSCHOCLOKBF',
  266486: 'LOSCHOCLOKBF',
  266423: 'LOSCHOCLOKBF',
  266422: 'LOSCHOCLOKBF',
  266586: 'LOSCHOCLOKBF',
  264153: 'LAGARFIELDBLACKF',
  263922: 'LAGARFIELD2X1',
  263920: 'LAGARFIELD2X1',
  261759: 'FEST2X1',
  264149: 'BUENFIN',
  264864: 'BUENFIN',
  264410: 'CASIFEB',
  266630: 'BUENFIN',
  267183: 'BUENFIN4X3',
  267178: '20OFF',
  253430: 'BUENFIN2X1',
  267099: 'BUENFIN',
  266164: 'BUENFIN',
  265992: 'BUENFIN',
  266091: 'BUENFIN',
  266057: 'BUENFIN',
  266090: 'BUENFIN',
  266084: 'BUENFIN',
  244330: 'BUENFIN20',
  266641: 'PROMO2X1',
  266644: 'PROMO2X1',
  267078: 'BUENFIN',
  267121: 'BUENFIN',
  267122: 'BUENFIN',
  267123: 'BUENFIN',
  267124: 'BUENFIN',
  267125: 'BUENFIN',
  267126: 'BUENFIN',
  267127: 'BUENFIN',
  266256: 'BUENFIN',
  265999: 'BUENFIN30',
  253465: 'BUENFIN',
  262586: 'BUENFIN25',
  264895: 'BUENFIN25',
  262664: 'BUENFIN25',
  264762: 'BUENFIN25',
  264965: '4X3',
  267486: 'LOSCHOCLOKBF',
  266061: '50OFF',
  266374: 'RICHIEMETEPEC',
  267533: '3X2',
  267530: '3X2',
  259843: 'BUENFIN',
  253386: 'BUENFIN',
  259460: 'BUENFIN',
  258906: 'BUENFIN',
  262490: 'BOLETIA',
  262314: 'BOLETIA',
  263870: 'BOLETIA',
  263871: 'BOLETIA',
  266466: 'CUPON2X1',
  267143: 'ESPECIAL2X1',
  260656: 'BUENFIN',
  262751: 'BOLETIA',
  252499: 'JUEVES2X1',
  267098: '2X1',
  267092: '2X1',
  263119: 'BOLETIA',
  266431: 'INVITADO2X1',
  266432: 'INVITADO2X1',
  266453: '2X1',
  267817: '3X2',
  268111: 'TEO30',
  265956: '2X1',
  259870: '2X1',
  268173: '12ANIV',
  267435: '12ANIV',
  267436: '12ANIV',
  266398: '2X1',
  266341: '450',
  267336: '2X1',
  267338: '2X1',
  267342: '2X1',
  267344: '2X1',
  267348: '2X1',
  267350: '2X1',
  268260: '2X1',
  267997: 'PREVENTA',
  266819: '2X1',
  268219: 'BOLETIA',
  268213: 'BOLETIA',
  268214: 'BOLETIA',
  267899: 'AMOR',
  267895: 'BOLETIA',
  267894: 'BOLETIA',
  265048: 'BOLETIA',
  265446: 'BOLETIA',
  270751: 'ESPECIAL3X2',
  269855: '3X2',
  269893: '3X2',
  266347: 'JUEVES2X1',
  267414: '2X1',
  268219: 'AMOR',
  268213: 'ANGELES',
  268214: 'ANGELES',
  263871: 'ANGELES',
  263870: 'ANGELES',
  271159: 'PREVENTA',
  267816: '30OFF',
  270878: '15OFF',
  270723: '25PREF',
  270722: '25PREF',
  270721: '25PREF',
  270720: '25PREF',
  268123: '30OFF',
  271154: 'G2X1',
  268376: '2X1',
  270347: 'PLATA20',
  268136: 'AMOR',
  267943: 'AMOR',
  267993: 'AMOR',
  267946: 'AMOR',
  268137: 'AMOR',
  268012: 'AMOR',
  268212: 'AMOR',
  267902: 'ANGELES',
  267904: 'ANGELES',
  267901: 'ANGELES',
  268013: 'AMOR',
  267900: 'AMOR',
  267898: 'ANGELES',
  267897: 'ANGELES',
  262491: 'AMOR',
  262292: 'AMOR',
  262494: 'AMOR',
  268135: 'AMOR',
  271114: 'AMOR',
  262492: 'AMOR',
  271319: '2X1',
  271151: 'AMOR',
  266826: 'INFINITYGOLD',
  266825: 'INFINITYGOLD',
  266824: 'INFINITYGOLD',
  266813: 'INFINITYGOLD',
  267721: '2X1GUATEMALA',
  267947: '2X1CDMX',
  267401: '2X1MTY',
  270776: 'QUEENT',
  267821: '20',
  267812: 'JUEVES20',
  271013: 'JUEVES2X1',
  271338: '3X2',
  271311: '3X2',
  271429: '3X2',
  271336: '3X2',
  271416: '3X2',
  264306: 'RITUAL',
  272491: 'PREVENTA20',
  272501: '3X2',
  265124: '2X1',
  266829: '30OFF',
  271999: '2X1',
  271014: '2X1',
  272651: '3X2',
  268264: 'EXAINVITA',
  266788: '2X1',
  272614: '3X2',
  273797: '2X1',
  271972: 'JOAN',
  272788: 'MARZO50',
  270707: '2X1',
  274339: '20',
  274338: '2X1',
  274337: '300',
  268544: '3X2',
  273894: 'PLATA20',
};

export const Templates = {
  PLUS: 1,
  HYBRID: 2,
  HIDDEN_MAP: 3,
};

const blockByToken = {
  264304: '8kx9MQR2snLPBweE5tvb7G',
  266674: '8kx9MQR2snLPBweE5tvb7G',
  266675: '8kx9MQR2snLPBweE5tvb7G',
  266676: '8kx9MQR2snLPBweE5tvb7G',
};

const eventsWithAddOns = [
  222939, 223067, 223069, 250620, 223242, 223246, 223255, 223262, 223273,
  251272, 251375, 251377, 251379, 251380, 245643, 250462, 249553, 243220,
  247206, 223302, 223303, 250252, 248826, 251188, 223307, 251307, 251155,
  251466, 251953,
];

const eventsWithSoldOutMessage = [
  271799, 271909, 271910, 271801, 271804, 271805, 271806, 271809, 271810,
  271811, 271814, 271816, 271818, 271830, 271786, 271813, 271794, 271817,
  271823, 271824, 271825, 271826, 271827, 271828, 271829, 271833, 271821,
  271812, 271834, 271822, 273864, 273869,
];

const eventsLng = [249553];

const eventsWithBestPlacesDisabled = [263058];

const eventsWithoutCustomization = [
  224058, 234371, 270981, 272553, 272296, 272293, 272647, 272648, 235697,
  272791, 240541, 276214, 276230, 276094, 276435, 276431, 276509, 277412,
  277581, 277336, 276167,
];

const eventsExtendWithoutCustomization = [240541, 276230, 276094, 276509, 277412, 277581, 277336];

export default function useBoletiaConfig() {
  const billboardsEventCardMobileBackgroundPosition = (billboardId) => {
    const toRight =
      BillboardsEventsMobileBackgroundPositionToRight.includes(billboardId);

    if (toRight) {
      return 'right';
    }

    return BillboardsEventsMobileBackgroundPositionToLeft.includes(billboardId)
      ? 'left'
      : 'center';
  };

  const isBillboardWithShortenTemplate = (billboardId) =>
    billboardsWithShortenTemplates.includes(billboardId);

  const eventUseNewCommision = (eventID, fee_breakdown) =>
    fee_breakdown !== 'f' && EventsWithNewCommissions.includes(eventID);

  const getTemplate = (event, user) => {
    if (user) {
      if (usersTemplateHybrid.includes(user)) {
        return Templates.HYBRID;
      }
      if (usersTemplateHiddenMap.includes(user)) {
        return Templates.HIDDEN_MAP;
      }
    }
    if (event) {
      if (eventsTemplateHybrid.includes(event)) {
        return Templates.HYBRID;
      }
      if (eventsTemplateHiddenMap.includes(event)) {
        return Templates.HIDDEN_MAP;
      }
    }
    return Templates.PLUS;
  };

  const isUserToViewAvailability = (user) =>
    userToViewAvailability.includes(user);

  const isEventToViewAvailability = (user) =>
    eventToViewAvailability.includes(user);

  const eventColorMode = (eventID) =>
    eventsWithDarkMode.includes(eventID) ? 'dark' : 'light';

  const isBillboardDisabledHighlightedEvents = () => true;

  const isBillboardsRemoveOpenCard = (billboardId) =>
    BillboardsRemoveOpenCard.includes(billboardId);

  const isBillboardRemoveEventsBanner = (eventID) =>
    BillboardRemoveEventsBanner.includes(eventID);

  const isEventsRemoveNoCustomTicketButton = (eventID) =>
    eventsRemoveNoCustomTicketButton.includes(eventID);
  const isEventsRemoveApplyAllCustomTicketButton = (eventID) =>
    eventsRemoveApplyAllCustomTicketButton.includes(eventID);

  const isBillboardsEventsWithMXN = (eventID) =>
    BillboardsEventsWithMXN.includes(eventID);

  const isEventsSoldOut = (eventID) => eventsSoldOut.includes(eventID);

  const isBillboardWithAllEvents = (billboardId) =>
    BillboardsWithAllEvents.includes(billboardId);

  const isBillboardOdysseySoldOut = (billboardId) =>
    BillboardOdysseySoldOut.includes(billboardId);

  const isBillboardsCardDefaultAction = (billboardId) =>
    BillboardsCardDefaultAction.includes(billboardId);

  const isBillboardsRemoveTags = (billboardId) =>
    BillboardsRemoveTags.includes(billboardId);

  const getPromotionPreLoaded = (eventID) => {
    return promotionPreLoaded[eventID] || null;
  };

  const requiredFanPass = (eventID) => {
    const fanPass = fanPassword[eventID];
    try {
      if (fanPass) {
        if (Array.isArray(fanPass)) {
          const item = fanPass.filter((current) => {
            return isToday(current.start_date, current.end_date);
          });
          return item;
        } else {
          if (isToday(fanPass.start_date, fanPass.end_date)) {
            return fanPass.pass;
          }
        }
      }
    } catch (e) {
      console.log('Error en Fan Pass', e);
    }

    return null;
  };

  const isBlockbyToken = (eventID) => {
    return blockByToken[eventID] || null;
  };

  const isEventsWithAddOns = (eventID) => eventsWithAddOns.includes(eventID);
  const isEventsLng = (eventID) => eventsLng.includes(eventID);

  const isEventWithSaleLabel = (eventId) =>
    eventsWithSaleLabel.includes(eventId);

  const isEventWithBestPlacesDisabled = (eventId) =>
    eventsWithBestPlacesDisabled.includes(eventId);

  const isEventWithSoldOutMessage = (eventId) =>
    eventsWithSoldOutMessage.includes(eventId);

  const isEventWithoutCustomization = (eventId) =>
    eventsWithoutCustomization.includes(eventId);

  const isEventExtendWithoutCustomization = (eventId) =>
    eventsExtendWithoutCustomization.includes(eventId);

  return {
    billboardsEventCardMobileBackgroundPosition,
    isBillboardWithShortenTemplate,
    eventUseNewCommision,
    getTemplate,
    isUserToViewAvailability,
    isEventToViewAvailability,
    eventColorMode,
    isBillboardDisabledHighlightedEvents,
    isBillboardsRemoveOpenCard,
    isEventsRemoveNoCustomTicketButton,
    isEventsRemoveApplyAllCustomTicketButton,
    isBillboardWithAllEvents,
    isBillboardsEventsWithMXN,
    isEventsSoldOut,
    isBillboardOdysseySoldOut,
    requiredFanPass,
    isBillboardsCardDefaultAction,
    isBillboardsRemoveTags,
    getPromotionPreLoaded,
    isBlockbyToken,
    isBillboardRemoveEventsBanner,
    isEventsWithAddOns,
    isEventsLng,
    isEventWithSaleLabel,
    isEventWithBestPlacesDisabled,
    isEventWithSoldOutMessage,
    isEventWithoutCustomization,
    isEventExtendWithoutCustomization,
  };
}
